export const translations = {
  nav: {
    aboutUs: "Tentang Kami",
    projects: "Proyek",
    services: "Layanan",
    contact: "Kontak Kami"
  },
  hero: {
    title: "Karya Artistika Nusaindo",
    subtitle: "Wujudkan impian Anda menjadi kenyataan!",
    description: "Kami memberikan hasil kerja dan keahlian yang luar biasa sesuai dengan kebutuhan Anda, mari kita bangun visi luar biasa Anda menjadi kenyataan bersama!",
    contactButton: "Hubungi Kami →"
  },
  clients: {
    title: "Klien Kami"
  },
  projects: {
    title: "Proyek Kami",
    description: "Kami telah bekerja dan menunjukkan komitmen tanpa lelah melalui karya kami, proyek-proyek terbaru kami menunjukkan bagaimana 5 tahun kerja keras dan kedisiplinan menghasilkan hasil yang luar biasa, berikut adalah proyek-proyek terbaru kami!",
    previousProjects: {
      title: "Proyek Sebelumnya",
      description: "Portofolio kami menampilkan berbagai proyek sukses yang menunjukkan keahlian dan komitmen kami terhadap keunggulan. Dari renovasi perumahan hingga pengembangan komersial, setiap proyek mencerminkan dedikasi kami terhadap kualitas pengerjaan dan solusi desain yang inovatif."
    },
    viewAll: "Lihat semua proyek →"
  },
  services: {
    title: "Layanan Kami",
    fitOut: {
      title: "Fit Out (Ruang Komersial & Retail)",
      description: "Mengubah ruang kosong menjadi lingkungan fungsional, kami mengkhususkan diri dalam fit out interior turnkey untuk mal, kantor, dan ruang retail."
    },
    interiorDesign: {
      title: "Desain Interior",
      description: "Tim kami menciptakan ruang yang harmonis dan berpusat pada pengguna melalui visualisasi 3D, perencanaan ruang, kurasi material, koordinasi furnitur, dan desain pencahayaan."
    },
    construction: {
      title: "Konstruksi Umum",
      description: "Dari bangunan komersial, proyek skala besar, hingga perumahan, kami membangun hampir semua jenis bangunan."
    }
  },
  footer: {
    tagline: "Wujudkan impian Anda menjadi kenyataan!"
  },
  aboutUs: {
    companyProfile: {
      title: "Profil Perusahaan",
      description: [
        "PT Karya Artistika Nusaindo adalah perusahaan kontraktor dinamis, disiplin, dan inovatif, secara khusus dalam interior fitout, desain interior, dan jasa konstruksi umum. Didirikan pada Juni 2020 oleh 3 profesional berpengalaman dari Tangerang, dimana perusahaan ini memulai perjalanannya sebagai tim kecil sederhana yang hanya berfokus pada interior fit out dengan cakupan terbatas.",
        "Berkat dedikasi, komitmen terhadap kualitas, serta keinginan untuk terus berkembang, PT Karya artistika Nusaindo telah memperluas layanannya untuk memenuhi kebutuhan klien yang semakin beragam. Kini PT KAN  mencampurkan kreativitas, desain timeless, dan ketepatan teknis untuk menyediakan solusi konstruksi yang lengkap dan layanan yang lebih beragam."
      ]
    },
    journey: {
      title: "Perjalanan Kami",
      items: [
        {
          year: "2020",
          description: "Didirikan di Tangerang sebagai tim kecil yang mengkhususkan diri dalam interior fit out, yang berfokus pada proyek lokal dengan keinginan untuk tumbuh dan belajar."
        },
        {
          year: "2020 - 2023",
          description: "Memperluas layanan dan tim kami untuk mencakup desain interior dan mulai mengambil proyek-proyek besar"
        },
        {
          year: "2024 - Sekarang",
          description: "Berkembang menjadi perusahaan konstruksi umum layanan lengkap, memberikan solusi yang sangat baik secara nasional, dan dipercaya sebagai perusahaan konstruksi yang rendah hati namun berdampak"
        }
      ]
    },
    values: {
      title: "Nilai-Nilai Kami",
      items: [
        {
          title: "Visi",
          points: [
            "Menjadi pemimpin terpercya dalam bidang konstruksi dan desain, mengubah ruang dengan inovasi, kreativitas, dan profesionalitas."
          ]
        },
        {
          title: "Misi",
          points: [
            "Menyediakan solusi konstruksi berkualitas tinggi.",
            "Terus meningkatkan keterampilan dan tekonologi untuk selalu unggul dalam duni industri.",
            "Membangun hubungan jangka panjang dengan para klien.",
            "Menghadirkan desain yang indah dan kuat/kokoh.",
            "Berorientasi pada waktu tenggat/deadline dan tujuan."
          ]
        }
      ]
    },
    management: {
      title: "Manajemen",
      members: [
        {
          name: "Tazim Samzir",
          position: "Direktur",
          description: "Dengan pengalaman puluhan tahun dan dedikasi tanpa henti di dunia konstruksi, beliau memimpin visi strategis perusahaan dengan integritas, inovasi, serta komitmen kuat terhadap keunggulan."
        },
        {
          name: "Andreas Prabowo",
          position: "Direktur Desain",
          description: "Andreas Prabowo menghadirkan perpaduan unik antara visi artistik dan keahlian teknis di PT KAN, sebagai direktur beliau mengawasi eksekusi kreatif, dan operasional perusahaan, memastikan setiap proyek dan aktivitas memadukan fungsionalitas dengan keindahan estetika."
        },
        {
          name: "Suriyanto",
          position: "Direktur Teknis",
          description: "Memberikan pengawasan strategis dan tata kelola untuk memastikan visi, misi, dan nilai nilai perusahaan selaras dengan pelaksanaan kerja dan inovasi."
        }
      ]
    },
    contact: {
      title: "Tertarik untuk berkolaborasi?",
      button: "Hubungi Kami →"
    }
  },
  contact: {
    title: "Hubungi Kami",
    formTitle: "Kirim pesan kepada kami",
    infoTitle: "Informasi Kontak",
    location: "Lokasi Kami",
    name: "Nama Anda",
    email: "Email Anda",
    message: "Pesan Anda",
    sendButton: "Kirim Pesan",
    address: "Alamat",
    phone: "Telepon",
    whatsappButton: "Chat di WhatsApp",
    description: "Jika Anda memiliki pertanyaan, jangan ragu untuk menghubungi kami melalui telepon, pesan teks, email, formulir di bawah ini, atau bahkan media sosial!"
  }
}; 